import { init } from 'zar';

var bhl_debug = false;
if (window.location.href && window.location.href.includes("bhl_debug")) {
  bhl_debug = true;
}

function rbCaptureEvent(data, level) {
  if (window.Rollbar) {
    window.Rollbar.captureEvent(data, level);
  }
}

function rbError(msg) {
  if (window.Rollbar) {
    window.Rollbar.error(msg);
  }
}

function initOnError() {
  window.onerror_old = window.onerror;
  window.onerror = function (msg, url, line, col, error) {
    if (window.onerror_old) { window.onerror_old(); }
    var errorDetails = error ? error.stack : ('url: ' + url + ' line:' + line + ' col: ' + col);
    if (window.ga) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Javascript Error',
        eventAction: msg,
        eventLabel: errorDetails,
        eventNonInteraction: true
      });
    }
  };
}

function trackCTAClicks() {
  try {
    var ctas = document.getElementsByClassName('call-to-action');
    var tracked = {};
    [].forEach.call(ctas, function (elem) {
      if (bhl_debug) {
        console.log("Adding CTA tracking:", elem);
      }
      ['click'].forEach(function (eventType) {
        elem.addEventListener(eventType, function (event) {
          if (elem in tracked) {
            // This is necessary to prevent double-tracking the event with the
            // click in setTimeout
            if (bhl_debug) {
              console.log("Event already tracked:", event);
            }
            delete tracked[elem];
            return;
          }

          event.preventDefault();
          tracked[elem] = true;

          if (bhl_debug) {
            console.log("Event:", event);
          }

          window._analytics.track(
            'call-to-action',
            {
              'category': elem.getAttribute('data-cta-category'),
              'label': elem.getAttribute('data-cta-label'),
              'vid': window.zar.getVID()
            },
            {
              plugins: {
                "google-tag-manager": false,
              }
            },
          );

          setTimeout(function () {
            event.target.click();
          }, 200);
        });
      });
    });
  } catch (error) {
    rbError("bhl_init_head:DOMContentLoaded: " + error.toString());
  }
}

function initAnalytics() {
  rbCaptureEvent({ 'step': 'bhl_init_analytics:start' }, 'info');

  var gtmConfig = null;
  if (window.gtmContainerId) {
    gtmConfig = { containerId: window.gtmContainerId };
  }
  var gaConfig = null;
  if (window.gaTrackingId) {
    gaConfig = {
      trackingId: window.gaTrackingId,
      customDimensions: {
        vid: 'dimension1',
      },
      cookieConfig: {
        cookieFlags: 'SameSite=None; Secure'
      }
    };
  }
  var ga4Config = null;
  if (window.ga4TrackingId) {
    ga4Config = {
      trackingId: window.ga4TrackingId,
      customDimensions: [
        {
          'name': 'vid',
          'callback': function (instance, config) { return instance.plugins.zar.getVID(); }
        }
      ]
    };
  }

  try {
    var _analytics = init({
      app: window.zarAppName,
      gtmConfig: gtmConfig,
      gaConfig: gaConfig,
      ga4Config: ga4Config,
      apiUrl: window.zarApiUrl,
      debug: false,
    });
    window._analytics = _analytics;
    window.zar = _analytics.plugins.zar;
  } catch (error) {
    rbError("bhl_init_analytics:zar: " + error.toString());
  }

  window._analytics.on('ready', function () {
    var zarReadyState = "page";
    try {
      window._analytics.page({
        // Pass in VID so its available to GA as custom dimension
        vid: window.zar.getVID()
      });

      zarReadyState = "experiments";

      // TODO: GA4 support
      var gaTrackingId = window.gaTrackingId;
      if (window.gaData && gaTrackingId && (gaTrackingId in window.gaData) && ('experiments' in window.gaData[gaTrackingId])) {
        window._analytics.track(
          'experiments',
          window.gaData[gaTrackingId].experiments,
          {
            plugins: {
              all: false,
              zar: true
            }
          }
        );
      }

      zarReadyState = "hasAdBlock";
      if (window.zar.hasAdBlock()) {
        window._analytics.track(
          'adblock',
          {
            // Pass in VID so its available to GA as custom dimension
            vid: window.zar.getVID()
          },
          {
            plugins: {
              "google-tag-manager": false,
            }
          }
        );
      }
    } catch (error) {
      rbError("bhl_init_analytics:zar ready: " + error.toString());
    }
  });

  rbCaptureEvent({ 'step': 'bhl_init_analytics:end' }, 'info');
}

function initTrackingPool() {
  if (typeof window.zarPoolId !== 'undefined') {
    rbCaptureEvent({ 'step': 'initTrackingPool:start' }, 'info');
    var ctas = document.querySelectorAll('.call-to-action[data-cta-category="click-to-call"]');
    if (typeof window._analytics !== 'undefined') {
      window.zar.initTrackingPool({
        poolId: window.zarPoolId,
        overlayElements: ctas,
        renew: true,
        renewalInterval: 30 * 1000,
        callback: function (result) {
          rbCaptureEvent({ 'step': 'initTrackingPool:end' }, 'info');
        }
      });
    }
  }
}

function injectCTARedirectValues() {
  if (typeof window.injectCTARedirects !== 'undefined') {
    rbCaptureEvent({ 'step': 'injectCTARedirects:start' }, 'info');
    var redirects = document.querySelectorAll('.call-to-action[data-cta-category="redirect"]');
    [].forEach.call(redirects, function (elem) {
      if (bhl_debug) {
        console.log("Injecting CTA redirect VIDs:", elem);
      }
      var vid = window.zar.getVID();
      elem.href = elem.href.replace("{vid}", vid).replace("%7Bvid%7D", vid);
    });
    rbCaptureEvent({ 'step': 'injectCTARedirects:end' }, 'info');
  }
}

function initReviewBlockLabels() {
  if (typeof window.labelReviewBlocks !== 'undefined') {
    rbCaptureEvent({ 'step': 'labelReviewBlocks:start' }, 'info');
    var blocks = document.querySelectorAll('.review-block');
    [].forEach.call(blocks, function (block) {
      if (bhl_debug) {
        console.log("Labeling review block:", block);
      }
      var nameDiv = block.querySelector('.review-block-name');
      if (!nameDiv) {
        if (bhl_debug) {
          console.log('Block is missing name:' + block);
        }
        return;
      }
      var blockName = nameDiv.getAttribute('data-block-name');
      var redirects = block.querySelectorAll('.call-to-action[data-cta-category="redirect"]');
      if (!redirects) {
        if (bhl_debug) {
          console.log('Block has no redirects:' + block);
        }
        return;
      }
      [].forEach.call(redirects, function (redirect) {
        if (bhl_debug) {
          console.log("Labeling redirect:", blockName, ":", redirect);
        }
        var label = redirect.getAttribute('data-cta-label');
        redirect.setAttribute('data-cta-label', label + ':' + blockName);
      });
    });
    rbCaptureEvent({ 'step': 'labelReviewBlocks:end' }, 'info');
  }
}

function initJotform() {
  if (typeof window.jotformForms !== 'undefined') {
    rbCaptureEvent({ 'step': 'bhl_init_jotform:start' }, 'info');
    window.jotformForms.forEach(function (formConfig) {
      bhl_init_jotform(formConfig.id, formConfig.scrollTop);
    });
    rbCaptureEvent({ 'step': 'bhl_init_jotform:end' }, 'info');
  }
}

function initGSC() {
  if (typeof window.gsc !== 'undefined') {
    rbCaptureEvent({ 'step': 'bhl_init_gsc:start' }, 'info');
    bhl_init_gsc();
    rbCaptureEvent({ 'step': 'bhl_init_gsc:end' }, 'info');
  }
}

function geoip(json) {
  var elem = document.getElementById("region");
  if (elem) {
    elem.innerHTML = json.region;
  }
}

function bhl_init_geojs() {
  window.geoip = geoip;
  if (window.location.search.indexOf("_geo=1") > -1) {
    var body = document.getElementsByTagName('body')[0];
    var js = document.createElement("script");
    js.type = "text/javascript";
    js.src = "https://get.geojs.io/v1/ip/geo.js";
    body.appendChild(js);
  }
}

function bhl_init_gsc() {
  window.gsc('params', {
    vid: window.zar.getVID()
  });
}

function bhl_init_jotform(formId, scrollTop) {
  try {
    scrollTop = (typeof scrollTop !== 'undefined') ? scrollTop : true;
    window.formStepCount = 0;
    var ifr = document.getElementById("JotFormIFrame-" + formId);

    var jotform_url = "https://form.jotform.com/" + formId;
    if (typeof window._analytics !== 'undefined') {
      var zarIDs = window.zar.getIds();
      ifr.src = jotform_url + "?_vid=" + zarIDs.vid + "&_sid=" + zarIDs.sid + "&_cid=" + zarIDs.cid;
    } else {
      ifr.src = jotform_url;
    }

    if (window.location && window.location.href && window.location.href.indexOf("?") > -1) {
      var get = window.location.href.substr(window.location.href.indexOf("?") + 1);
      if (ifr && get.length > 0) {
        var src = ifr.src;
        src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
        ifr.src = src;
        ifr.src += (ifr.src.indexOf("?") > -1 ? "&" : "?") + "isIframeEmbed=1";
      }
    }
  } catch (error) {
    rbError("bhl_init_jotform: " + error.toString());
  }

  window.handleIFrameMessage = function (e) {
    if (typeof e.data === 'object' || typeof e.data === 'boolean' || !e.data) {
      return;
    }
    try {
      var args = e.data.split(":");
      var iframe;
      if (args.length > 2) {
        iframe = document.getElementById("JotFormIFrame-" + args[(args.length - 1)]);
      } else {
        iframe = document.getElementById("JotFormIFrame");
      }
      if (!iframe) { return; }
      switch (args[0]) {
        case "scrollIntoView":
          if (!scrollTop) {
            iframe.scrollIntoView();
          } else {
            window.parent.scrollTo(0, 0);
            window.scrollTo(0, 0);
          }
          window.formStepCount++;
          if (typeof window._analytics !== 'undefined') {
            window._analytics.track(
              'form-step',
              { "form_source": 'jotform', "form_id": args[(args.length - 1)], "step_count": window.formStepCount },
              {
                plugins: {
                  "google-tag-manager": false,
                }
              }
            );
          }
          break;
        case "setHeight":
          iframe.style.height = args[1] + "px";
          break;
        case "collapseErrorPage":
          if (iframe.clientHeight > window.innerHeight) {
            iframe.style.height = window.innerHeight + "px";
          }
          break;
        case "reloadPage":
          window.location.reload();
          break;
        case "loadScript":
          var src = args[1];
          if (args.length > 3) {
            src = args[1] + ':' + args[2];
          }
          var script = document.createElement('script');
          script.src = src;
          script.type = 'text/javascript';
          document.body.appendChild(script);
          break;
        case "exitFullscreen":
          if (window.document.exitFullscreen) window.document.exitFullscreen();
          else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();
          else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();
          else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();
          else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
          break;
      }
      var isJotForm = (e.origin.indexOf("jotform") > -1) ? true : false;
      if (isJotForm && "contentWindow" in iframe && iframe.contentWindow && "postMessage" in iframe.contentWindow) {
        var urls = { "docurl": encodeURIComponent(document.URL), "referrer": encodeURIComponent(document.referrer) };
        iframe.contentWindow.postMessage(JSON.stringify({ "type": "urls", "value": urls }), "*");
      }
    } catch (error) {
      rbError("handleIFrameMessage: " + JSON.stringify(e) + " / " + JSON.stringify(e.data) + " / " + typeof e.data + " / " + error.toString());
    }
  };
  if (window.addEventListener) {
    window.addEventListener("message", window.handleIFrameMessage, false);
  } else if (window.attachEvent) {
    window.attachEvent("onmessage", window.handleIFrameMessage);
  }
}

function bhl_init() {
  initOnError();
  initAnalytics();

  window.addEventListener('DOMContentLoaded', function (event) {
    trackCTAClicks();
    initTrackingPool();
    injectCTARedirectValues();
    initReviewBlockLabels();
    initJotform();
    initGSC();
  });
}

// Initialization executed on script load
bhl_init();

export { bhl_init, bhl_init_geojs, geoip, bhl_init_jotform, bhl_init_gsc };


